const actions = {
    async initDatadog({ commit, rootGetters }) {
      if(process.env.VUE_ADM_PAGE.replace(/^https?:\/\//, '').replace(/\/$/, '') === 'adm.voompcreators.com.br') {
        const script = document.createElement('script');
        script.name = 'DD_RUM';
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = 'https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js';
        script.onload = function() {
          window.DD_RUM.onReady(function() {
            window.DD_RUM.init({
              clientToken: 'pub8b3193a590795fb42020fe0b71c914e4',
              applicationId: 'fc30e078-25df-46ac-b591-1e5b9419758a',
              // `site` refers to the Datadog site parameter of your organization
              // see https://docs.datadoghq.com/getting_started/site/
              site: 'datadoghq.com',
              service: 'voomp-admin',
              env: 'prd',
              // Specify a version number to identify the deployed version of your application in Datadog
              // version: '1.0.0',
              sessionSampleRate: 100,
              sessionReplaySampleRate: 20,
              defaultPrivacyLevel: 'mask-user-input',
            });
          });
        };
        document.head.appendChild(script);
        console.log("datadog started!")
      } else {
        console.log("datadog didn't start!")
      }
    }
}

export default actions
